module.exports = __webpack_public_path__ + "img/Room5_009.a09549dd.svg";